import React from 'react';
import ReactDOM from 'react-dom';
import { FocusStyleManager } from '@blueprintjs/core';
import 'tailwindcss/tailwind.css';
import 'react-activity/dist/react-activity.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import './index.css';

import { Application } from './Application';

FocusStyleManager.onlyShowFocusOnTabs();

ReactDOM.render(<Application />, document.getElementById('root'));
